import { List, Tooltip, useToggle } from '@factorialco/deprecated-design-system'

interface Props {
  teamName: string
}

const TeamName = ({ teamName }: Props) => {
  const [open, toggle] = useToggle(false)

  return (
    <Tooltip
      attachment="middle left"
      targetAttachment="middle right"
      type="black"
      size="small"
      open={open}
      toggle={toggle}
    >
      <List.Title ellipsis>{teamName}</List.Title>
      <div>{teamName}</div>
    </Tooltip>
  )
}

export default TeamName
